const Header = () => {
  return (
    <header>
      <h1>Shopper2</h1>
    </header>
  );
}

export default Header;